import { DashboardPage } from "pages/dashboard";
import { PracticesPage } from "pages/practices";
import { HomePage } from "pages/home";
import { MySocialReportsPage } from "pages/my-social-reports";
import { SearchesPage } from "pages/searches";
import { SocialPage } from "pages/social";
import { PracticeDetailPage } from "pages/practice-detail";
import { AdminPage } from "pages/admin";
import { AdminUsagePage } from "pages/admin-usage";
import { MyProfilePage } from "pages/my-profile";
import { DomainsPage } from "pages/domains";
import { UrlDetailPage } from "pages/url-detail";
import { ConfigurationPage } from "pages/configuration";
import { ThermsAndConditions } from "pages/therms-and-conditions";
import { NewsPage } from "pages/news";
import { TakedownPage, TakedownListPage, UserRemovals } from "pages/takedown";
import {
  ClientSearchesListPage,
  ClientSearchDetailPage,
} from "pages/client-searches";
import { RoleRoute } from "components/atoms/role-route";
import { ADMIN_ROLES, OPERATOR_ROLES } from "core/constants/roles";

const routes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/web-rep/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/web-rep/searches",
    element: <SearchesPage />,
  },
  // {
  //   path: "/web-rep/reports",
  //   element: <ReportsPage />,
  // },
  {
    path: "/web-rep/practices",
    element: <PracticesPage />,
  },
  {
    path: "/web-rep/practices/:id",
    element: <PracticeDetailPage />,
  },
  {
    path: "/web-rep/practices/:id/:url_id",
    element: <UrlDetailPage />,
  },
  // {
  //   path: "/web-rep/favourite-urls",
  //   element: <FavouriteUrlPage />,
  // },
  {
    path: "/social/instagram-account",
    element: <SocialPage />,
  },
  {
    path: "/social/my-social-reports",
    element: <MySocialReportsPage />,
  },
  {
    // Pannello utenti: crediti e livello di QUALSIASI account. Solo admin.
    path: "/web-rep/admin",
    element: (
      <RoleRoute roles={ADMIN_ROLES}>
        <AdminPage />
      </RoleRoute>
    ),
  },
  {
    path: "/web-rep/admin/usage",
    element: (
      <RoleRoute roles={ADMIN_ROLES}>
        <AdminUsagePage />
      </RoleRoute>
    ),
  },
  {
    path: "/social",
    element: <></>,
  },
  {
    path: "/my-profile",
    element: <MyProfilePage />,
  },
  {
    // Rubrica domini: strumento di lavoro dell'operatore (GET /admin/domains).
    path: "/web-rep/domains",
    element: (
      <RoleRoute roles={OPERATOR_ROLES}>
        <DomainsPage />
      </RoleRoute>
    ),
  },
  {
    // Console takedown: prepara/approva/spedisce diffide per conto di altri.
    // Le rotte dietro sono @legal_auth, la vista end-user e' /web-rep/removals.
    path: "/web-rep/takedown",
    element: (
      <RoleRoute roles={OPERATOR_ROLES}>
        <TakedownListPage />
      </RoleRoute>
    ),
  },
  {
    path: "/web-rep/takedown/:practiceId",
    element: (
      <RoleRoute roles={OPERATOR_ROLES}>
        <TakedownPage />
      </RoleRoute>
    ),
  },
  {
    // Ricerche di TUTTI i clienti (anche quelle create da RM per il monitoraggio):
    // l'operatore sceglie i link e crea la pratica intestata al cliente, senza
    // scalargli crediti. Pagina solo admin (decisione 2026-10-05); le API restano
    // @legal_auth come la console takedown (GET/POST /legals/searches).
    path: "/web-rep/client-searches",
    element: (
      <RoleRoute roles={ADMIN_ROLES}>
        <ClientSearchesListPage />
      </RoleRoute>
    ),
  },
  {
    path: "/web-rep/client-searches/:searchId",
    element: (
      <RoleRoute roles={ADMIN_ROLES}>
        <ClientSearchDetailPage />
      </RoleRoute>
    ),
  },
  {
    // Vista end-user "Le tue rimozioni" (GET /account/removals, simple_auth)
    path: "/web-rep/removals",
    element: <UserRemovals />,
  },
  {
    path: "/web-rep/configuration",
    element: <ConfigurationPage />,
  },
  {
    path: "/tos",
    element: <ThermsAndConditions />,
  },
  {
    // Pagina Novità — non ancora collegata al menu (accessibile via URL diretto)
    path: "/news",
    element: <NewsPage />,
  },
];

export default routes;
